import env from "../env"

// 更新相关的的事件回调列表
// 触发检查更新回调列表
let checkUpdateHandlers = []
// 检查更新出错回调列表
let checkUpdateErrHandlers = []
// 有新的更新回调列表
let updateAvailableHandlers = []
// 没有新的更新回调列表
let updateNotAvailableHandlers = []
// 更新下载进度回调列表
let updateDownloadProgressHandlers = []
// 更新下载完成回调列表
let updateDownloadedHandlers = []

// 触发检查更新
let checkUpdate = function(checkResultHandler) {
    checkResultHandler("Not support this running env")
}

// 向检查更新事件添加回调
// handler 没有参数
let addHandlerForCheckUpdate = function(handler) {
    checkUpdateHandlers.push(handler)
}
// 向检查更新出错事件添加回调
// handler 参数: event, error
let addHandlerForCheckUpdateErr = function(handler) {
    checkUpdateErrHandlers.push(handler)
}
// 向更新可用事件添加回调
// handler 参数: event, info
let addHandlerForUpdateAvailable = function(handler) {
    updateAvailableHandlers.push(handler)
}
// 向更新不可用事件添加回调
// handler 参数: event, info
let addHandlerForUpdateNotAvailable = function(handler) {
    updateNotAvailableHandlers.push(handler)
}
// 向更新下载进度事件添加回调
// handler 参数: event, progress
// progress.total Bytes Number 总字节数
// progress.delta Bytes Number 距离上次本时间触发后下载的字节数
// progress.transferred Number 已传输字节数
// progress.percent Number 以传输百分比(有小数点, e.g: 89.54332120097385)
// progress.bytesPerSecond Bytes Number
let addHandlerForUpdateDownloadProgress = function(handler) {
    updateDownloadProgressHandlers.push(handler)
}
// 向更新包下载完成事件添加回调
// handler 参数: info UpdateInfo — for generic and github providers. VersionInfo for Bintray provider.
let addHandlerForUpdateDownloaded = function(handler) {
    updateDownloadedHandlers.push(handler)
}


if (env.isElectron) {
    const { ipcRenderer } = window.require("electron")

    checkUpdate = (checkResultHandler) => { 
        ipcRenderer.once("checkForUpdateResult", (event, checkResult) => {
            console.log("checkForUpdateResult: event:", event)
            checkResultHandler(checkResult)
        })
        ipcRenderer.send('checkForUpdate')
    }

    ipcRenderer.on('checking-for-update', () => {
        checkUpdateHandlers.forEach((handler) => { 
            handler() 
        })
    })

    ipcRenderer.on('checking-for-update-error', (event, err) => {
        checkUpdateErrHandlers.forEach((handler) => { 
            handler(event, err) 
        })
    })
    ipcRenderer.on('update-available', (event, info) => {
        updateAvailableHandlers.forEach((handler) => { 
            handler(event, info) 
        })
    })
    ipcRenderer.on('update-not-available', (event, info) => {
        updateNotAvailableHandlers.forEach((handler) => { 
            handler(event, info) 
        })
    })

    // progress.total Bytes Number 总字节数
    // progress.delta Bytes Number 距离上次本时间触发后下载的字节数
    // progress.transferred Number 已传输字节数
    // progress.percent Number 以传输百分比(有小数点, e.g: 89.54332120097385)
    // progress.bytesPerSecond Bytes Number
    ipcRenderer.on('update-download-progress', (event, progress) => {
        updateDownloadProgressHandlers.forEach((handler) => { 
            handler(event, progress) 
        })
    })

    // info UpdateInfo — for generic and github providers. VersionInfo for Bintray provider.
    ipcRenderer.on('update-downloaded', (info) => {
        updateDownloadedHandlers.forEach((handler) => { 
            handler(info) 
        })
    })

}

export default {
    checkUpdate,
    addHandlerForCheckUpdate,
    addHandlerForCheckUpdateErr,
    addHandlerForUpdateAvailable,
    addHandlerForUpdateNotAvailable,
    addHandlerForUpdateDownloadProgress,
    addHandlerForUpdateDownloaded,
}